const queryKeys = {
  DASHBOARDS: "dashboards",
  REPORTS: "reports",
  REPORTS_EXPORT: "reports export",
  SEND_REPORT_EMAIL: "report send email",
  ORGANIZATIONS: "organizations"
};

export default queryKeys;
